import React from 'react';
import BlueDropDown from '../PageLayout/DropDowns/BlueDropDown'

export const SortByMode = ({onItemClick, selectedItem}) => {
  return (
    <div className="ui-select--sortByMode">
      <BlueDropDown items={['All', 'Bathroom', 'Kitchen']}
                    onItemClick={onItemClick}
                    selectedItem={selectedItem}
                    itemKey={(item) => item.text}
                    itemValue={(item) => item.text}
                    templateType='gray'/>
    </div>
  );
};
